import styled from 'styled-components';

import { colorUsage } from 'stylesheetB2c';

export const HEADER_Z_INDEX = 2;
export const CONTENT_AREA_Z_INDEX = HEADER_Z_INDEX - 1;

export const StyledHeaderContainer = styled.header`
  background-color: ${colorUsage.bamOnline.headerBackground};
  display: flex;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  z-index: ${HEADER_Z_INDEX};
`;
StyledHeaderContainer.displayName = 'StyledHeaderContainer';
